import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { ListGrid } from 'components/organisms'
import { contentTypesArray, contentTypesNames } from 'interfaces/contentTypeInterface'
import * as S from './styled'

const Search = ({ search, searchQuery, zone, handleStatus }) => {
  const [uniqueContentTypes, setUniqueContentTypes] = useState([])

  const contentTypes =
    search?.data && Array.isArray(search.data)
      ? search?.data.filter(item => contentTypesArray.includes(item.type)).map(item => item.type)
      : []

  useEffect(() => {
    setUniqueContentTypes([...new Set(contentTypes)])
  }, [search])

  return (
    <S.Container>
      {uniqueContentTypes.length > 0 ? (
        uniqueContentTypes.map(contentType => (
          <S.Section key={contentType}>
            <S.SectionTitle>{contentTypesNames(contentType)}</S.SectionTitle>
            <ListGrid
              contentType={contentType}
              zone={zone}
              items={search?.data?.filter(el => el.type === contentType)}
              itemHeight='225px'
              handleStatus={handleStatus}
              isSearch
            />
          </S.Section>
        ))
      ) : (
        <S.NoResultsContainer>
          <S.NoResults>{searchQuery !== '' ? 'No results found' : 'Please, insert search term'}</S.NoResults>
        </S.NoResultsContainer>
      )}
    </S.Container>
  )
}

Search.propTypes = {
  search: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  zone: PropTypes.string.isRequired,
  handleStatus: PropTypes.func.isRequired,
  searchQuery: PropTypes.string.isRequired,
}

export default Search
